(function (angular) {
	'use strict';

	var animatedLockIconObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			'locked': '<?',
			'size': '@?'
		},
		controller: [
			'$element',
			'$timeout',
			'Big',
			AnimatedLockIconFunction
		],
		controllerAs: 'animatedLockIcon'
	};

	angular
		.module('serviceLevelModule')
		.component('animatedLockIcon', animatedLockIconObject);

	function templateUrlFunction(STATIC_BASE_PATH) {
		return STATIC_BASE_PATH + '/static/html/service-level/animated-lock-icon.html';
	}

	function AnimatedLockIconFunction(
		$element,
		$timeout,
		Big) {

		var animatedLockIcon = this;

		function playUnlockAnimation() {
			
			$timeout(function() {
				animatedLockIcon.unlocking = true;
			}, 500);

			$timeout(function() {
				animatedLockIcon.unlocking = false;
				animatedLockIcon.unlocked = true;
			}, 2500);
		}

		animatedLockIcon.$onInit = function() {
			$element.addClass('animated-lock-icon');
		};

		animatedLockIcon.$onChanges = function(changeObj) {
			if(animatedLockIcon.size === 'large') {
				$element.addClass('animated-lock-icon--large');
			}
			if(animatedLockIcon.locked === false) {
				playUnlockAnimation();
			} else {
				animatedLockIcon.unlocking = false;
				animatedLockIcon.unlocked = false;
			}
		};
	}
})(window.angular);